<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div class="container-custom-content">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">

            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="!isInRole('DISTRIBUIDOR')">

                <mat-form-field color="accent-darker" appearance="outline">
                    <mat-label>{{Etiquetas.FiltrarDeposito}}</mat-label>
                    <mat-select [(value)]="selectedDeposito" [disabled]="bloquearSeleccionDeposito"
                        (selectionChange)="seleccionarDeposito($event.value)">
                        <mat-option [value]="-1">- Seleccione -</mat-option>
                        <mat-option *ngFor="let d of depositos" [value]="d">
                            {{d.descripcion}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
                [hidden]="depositoSeleccionado == null || (depositoSeleccionado != null && depositoSeleccionado.cliente)">
                <mat-form-field color="accent-darker" appearance="outline">
                    <mat-label>{{Etiquetas.Almacen}}</mat-label>
                    <mat-select (selectionChange)="seleccionarAlmacen($event.value)">
                        <mat-option [value]="-1">- Seleccione -</mat-option>
                        <mat-option *ngFor="let alm of almacenes" [value]="alm">
                            {{alm.id}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
                *ngIf="depositoSeleccionado != null && depositoSeleccionado.cliente && !isInRole('DISTRIBUIDOR')">
                <mat-form-field color="accent-darker" appearance="outline">
                    <input (change)="handleEmptyInput($event)" matInput [(ngModel)]="distribuidorSeleccionado"
                        [matAutocomplete]="auto" [formControl]="formControlAutocomplete"
                        placeholder="Nro.cliente o razón social...">
                    <button type="button" matSuffix mat-icon-button matTooltip="Limpiar distribuidor seleccionado"
                        (click)="limpiarDistribuidor()">
                        <mat-icon color="accent-darker">close</mat-icon>
                    </button>

                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="seleccionarDistribuidor()"
                        [displayWith]="getOptionText">
                        <mat-option *ngIf="isLoading" class="is-loading cuit-option">Cargando...</mat-option>
                        <ng-container *ngIf="!isLoading">
                            <mat-option class="cuit-option" *ngFor="let d of filteredOptions " [value]="d">
                                {{d.displayValue}}
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>

                </mat-form-field>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" [hidden]="!direcciones.length">
                <mat-form-field color="accent-darker" appearance="outline">
                    <mat-label>{{Etiquetas.FiltrarDireccion}}</mat-label>
                    <mat-select (selectionChange)="seleccionarDireccion($event.value)">
                        <mat-option [value]="-1">- Seleccione -</mat-option>
                        <mat-option *ngFor="let dir of direcciones" [value]="dir">
                            {{dir.ciudad}} - {{dir.calleNro}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <mat-toolbar class="justify-content-start" *ngIf="selectedDeposito?.descripcion === 'Distribuidor'">

                <button style="margin-left: 1%" mat-flat-button color="accent" [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">
                    <mat-icon>download</mat-icon>
                    <span> Exportar a Excel</span>

                </button>
                <mat-menu style="margin-right: 1%" #menu="matMenu">

                    <button (click)="cExcelDistribuidoresXCantidadDisponible()" mat-menu-item color="accent">
                        <span>Distribuidores por cantidad disponible</span>
                    </button>

                    <button (click)="cExcelDistribuidoresXLotes()" mat-menu-item color="accent">
                        <span>Distribuidores por lotes</span>
                    </button>

                </mat-menu>


            </mat-toolbar>

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" [hidden]="depositoSeleccionado == null">


                <mat-form-field color="accent-darker" appearance="standard">
                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                    <input matInput (keyup)="applyFilterConsolidados($event)" #input>
                </mat-form-field>
                <div class="mat-table-stock-consolidado">
                    <table mat-table matTableResponsive [dataSource]="dataSourceConsolidados" matSort
                        #matSortConsolidados="matSort" matSortActive="idProducto" matSortDirection="asc">

                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Acciones}} </th>
                            <td mat-cell *matCellDef="let c">
                                <div>

                                    <button matTooltip="Ver stock por lote para este producto" mat-icon-button
                                        (click)="seleccionarProducto(c)" color="primary-darker">
                                        <mat-icon color="accent-darker">arrow_circle_right</mat-icon>
                                    </button>

                                </div>

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="idCompania">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.IdCompania}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.idCompania}} </td>
                        </ng-container>
                        <ng-container matColumnDef="idSalesOrg">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.IdSalesOrg}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.idSalesOrg}} </td>
                        </ng-container>

                        <ng-container matColumnDef="idProducto">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.IdProducto}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.idProducto}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="producto">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.Producto}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.producto}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cantidadDisponible">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.CantidadDisponible}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.cantidadDisponible | number : '1.3-3'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cantidadDisponibleVigente">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.CantidadDisponibleVigente}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.cantidadDisponibleVigente | number : '1.3-3'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cantidadPedidos">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.CantidadPedidos}}
                            </th>
                            <td (click)="dialogStockPedidos(c)" mat-cell *matCellDef="let c"
                                [ngClass]="depositoSeleccionado != null && c.cantidadPedidos > 0 ? 'stockPedidos' : ''">
                                {{c.cantidadPedidos | number : '1.3-3'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cantidadDisponibleVenta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.CantidadDisponibleVenta}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.cantidadDisponibleVenta | number : '1.3-3'}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsConsolidados"></tr>
                        <tr mat-row *matRowDef="let c; columns: displayedColumnsConsolidados;">
                        </tr>


                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumnsConsolidados.length">
                                {{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator #matPaginatorConsolidados="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </div>

    </div>

    <div class="container-fluid" [hidden]="productoSeleccionado == null">



        <mat-toolbar class="mb-2 mt-2">
            <div class="container-fluid">
                <div class="d-flex align-items-baseline justify-content-between ">
                    <div>

                        <p *ngIf="productoSeleccionado != null" class="p-fecha">Producto:
                            {{productoSeleccionado.idProducto}} - {{productoSeleccionado.producto}}
                        </p>
                    </div>

                </div>
            </div>



        </mat-toolbar>

        <!-- <div>

            <div *ngIf="dataSourcePorLote.data.length">
                <div
                    [ngClass]="isMobileXL() ? 'container d-flex flex-column pt-3 pb-3' : 'container-fluid d-flex align-items-center justify-content-end'">

                    <button mat-button color="accent" (click)="exportarExcel()">
                        <mat-icon>download</mat-icon>
                        Exportar a excel
                    </button>
                </div>
            </div>
        </div> -->


        <div class="mt-3 mb-1">

            <div class="container-fluid">
                <div class="row align-items-center justify-content-evenly">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                        <mat-form-field color="accent-darker" appearance="standard">
                            <mat-label>{{Etiquetas.Buscar}}</mat-label>
                            <input matInput (keyup)="applyFilterPorLote($event)" #input>
                        </mat-form-field>

                        <div class="mat-table-stock-por-lote">
                            <table mat-table matTableResponsive [dataSource]="dataSourcePorLote" matSort
                                #matSortPorLote="matSort" matSortActive="idLote" matSortDirection="asc">


                                <ng-container matColumnDef="idUbicacionAlmacenamiento">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Almacen}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.idUbicacionAlmacenamiento}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="idLote">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Headers.IdLote}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.idLote}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="cantidadDisponible">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Headers.CantidadDisponible}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.cantidadDisponible | number : '1.3-3'}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="cantidadTransito">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Headers.CantidadTransito}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.cantidadTransito | number : '1.3-3'}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="cantidadTransitoDevolucion">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Headers.CantidadTransitoDevolucion}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.cantidadTransitoDevolucion | number : '1.3-3'}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="idUnidadMedidaBase">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Headers.IdUnidadMedidaBase}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.idUnidadMedidaBase}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="estado">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Headers.Estado}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.estado}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="fechaVencimientoLote">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Headers.FechaVencimientoLote}}
                                    </th>
                                    <td mat-cell *matCellDef="let l">
                                        {{l.fechaVencimientoLote | date:'dd/MM/yyyy'}}
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsPorLote"></tr>
                                <tr mat-row *matRowDef="let c; columns: displayedColumnsPorLote;">
                                </tr>


                                <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                    <td class="mat-cell" [attr.colspan]="displayedColumnsPorLote.length">
                                        {{Etiquetas.SinRegistros}}
                                    </td>
                                </tr>
                            </table>

                            <mat-paginator #matPaginatorPorLote="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                                showFirstLastButtons>
                            </mat-paginator>
                        </div>


                    </div>

                </div>

            </div>

        </div>

    </div>

</div>